<template>
  <div>
    <el-input @input="handleInput" v-model="phone" :readonly="readonly" type="tel" :placeholder="$t('994_')"
      v-mask="'+994 (##) ###-##-##'" @click="onTelClick" />
  </div>
</template>

<script>
import { mask } from "vue-the-mask";
export default {
  directives: { mask },
  props: {
    value: String,
    readonly: { type: Boolean, default: false },
  },
  data() {
    return {
      phone: this.value,
      disabled: this.readonly,
    };
  },
  methods: {
    onTelClick() {
      if (!this.phone) this.phone = "+994 (";
    },
    handleInput(e) {
      this.$emit("input", this.phone === "+994 (" ? "" : this.phone);
    },
  },
  watch: {
    value() {
      this.phone = this.value;
    },
    readonly() {
      this.disabled = this.readonly;
    },
  },
};
</script>

<style lang="scss" scoped>

</style>